import {
  FileEntity,
  FileTypeName,
  LegalClientRepresentativeEntity,
} from 'api/types/entity';
import { parseListDocumentsFiles } from 'modules/client/common/helpers';

export const parseLegalClientRepresentativeDocumentsFiles = (
  client: LegalClientRepresentativeEntity
): FileEntity[] =>
  parseListDocumentsFiles([
    {
      files: client.additionalDocumentFiles,
      type: FileTypeName.AdditionalDocument,
      uploadedByAdmin: true,
    },
    {
      files: client.company?.constitutionalDocument?.files,
      type: FileTypeName.ConstitutionalDocument,
    },
  ]);
